import { Navigate, Outlet, type RouteObject } from "react-router-dom";
import { useAuth } from "@/app/providers/AuthProvider";
import { AppShell } from "@/app/shell/AppShell";
import { LoginPage } from "@/features/auth/pages/LoginPage";
import { DashboardPage } from "@/features/dashboard/pages/DashboardPage";
import { SubscribeListPage } from "@/features/subscribe/pages/SubscribeListPage";
import { DiscoverPage } from "@/features/discover/pages/DiscoverPage";
import { SearchPage } from "@/features/search/pages/SearchPage";
import { DownloadPage } from "@/features/download/pages/DownloadPage";
import { TransferPage } from "@/features/transfer/pages/TransferPage";
import { LibraryPage } from "@/features/library/pages/LibraryPage";
import { SitesPage } from "@/features/sites/pages/SitesPage";
import { SettingsPage } from "@/features/settings/pages/SettingsPage";
import { MediaDetailPage } from "@/features/media/pages/MediaDetailPage";
import { WizardPage } from "@/features/wizard/pages/WizardPage";

function RequireAuth() {
  const { isAuthenticated } = useAuth();
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  return <Outlet />;
}

export const routes: RouteObject[] = [
  { path: "/login", element: <LoginPage /> },
  {
    element: <RequireAuth />,
    children: [
      {
        element: <AppShell />,
        children: [
          { index: true, element: <DashboardPage /> },
          { path: "wizard", element: <WizardPage /> },
          { path: "subscribe", element: <SubscribeListPage /> },
          { path: "discover", element: <DiscoverPage /> },
          { path: "search", element: <SearchPage /> },
          { path: "media/:mediaid", element: <MediaDetailPage /> },
          { path: "download", element: <DownloadPage /> },
          { path: "transfer", element: <TransferPage /> },
          { path: "library", element: <LibraryPage /> },
          { path: "sites", element: <SitesPage /> },
          { path: "settings", element: <SettingsPage /> },
        ],
      },
    ],
  },
  { path: "*", element: <Navigate to="/" replace /> },
];
